<template>
  <div>
    <a-modal
      title="Contact Information"
      :visible="bookNo !== null"
      :maskClosable="false"
      @cancel="handleContactModalCancel"
    >
      <a-form layout='horizontal' :form="contactForm" class="contactInfoBox">
        <a-form-item>
          <a-textarea
            placeholder="Contact Remark"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleContactModalConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'ContactInformation',
  components: {
  },
  props: {
    bookNo: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showContactModal:false,
      contactForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleContactModalCancel () {
      this.$emit('cancel')
    },
    handleContactModalConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
</style>